import React from "react";

import Navbar from "../components/Navbar";
import Sidebar from "../components/Sidebar";

function InspectionPhoto() {

  return (

    <div>

      <Navbar />

      <Sidebar />

      <div
        style={{
          marginLeft: "240px",
          padding: "20px"
        }}
      >

        <h1>Inspection Photos</h1>

        <p>Inspection photos page</p>

      </div>

    </div>
  );
}

export default InspectionPhoto;